import {
  Specification,
  SpecificationWare,
} from '../../../../../types/specification';

export class SetSpecification {
  static readonly type = '[Specification] Set Specification';
  constructor(public specification: Specification) {}
}

export class UpdateSpecification {
  static readonly type = '[Specification] Set Specification';
  constructor(public specification: Omit<Specification, 'wares'>) {}
}

export class SpecificationAddWareItems {
  static readonly type = '[Specification] Add Ware Item';
  constructor(public wares: SpecificationWare[]) {}
}

export class SpecificationUpdateWareItems {
  static readonly type = '[Specification] Update Ware Items';
  constructor(public wares: SpecificationWare[]) {}
}

export class SpecificationDeleteWareItems {
  static readonly type = '[Specification] Delete Ware Item';
  constructor(public wares: SpecificationWare[]) {}
}

export class SpecificationReplaceWareItems {
  static readonly type = '[Specification] Replace Wares';
  constructor(public wares: SpecificationWare[]) {}
}
